// F-MOTOR-RESERVAS.3.1.4 — Máscaras + validações do formulário público.
// Decisão D4 (aprovada): CPF validado algorítmicamente (dígito verificador)
// antes do submit. Decisão D5 (aprovada): observações opcionais, limite 500.

/** Mantém apenas dígitos. */
export const onlyDigits = (s) => String(s || "").replace(/\D/g, "");

/** Aplica máscara progressiva 000.000.000-00. */
export function maskCPF(raw) {
  const d = onlyDigits(raw).slice(0, 11);
  if (d.length <= 3) return d;
  if (d.length <= 6) return `${d.slice(0, 3)}.${d.slice(3)}`;
  if (d.length <= 9) return `${d.slice(0, 3)}.${d.slice(3, 6)}.${d.slice(6)}`;
  return `${d.slice(0, 3)}.${d.slice(3, 6)}.${d.slice(6, 9)}-${d.slice(9)}`;
}

/** Aplica máscara progressiva (00) 00000-0000 (celular) ou (00) 0000-0000 (fixo). */
export function maskTelefone(raw) {
  const d = onlyDigits(raw).slice(0, 11);
  if (d.length === 0) return "";
  if (d.length <= 2) return `(${d}`;
  if (d.length <= 6) return `(${d.slice(0, 2)}) ${d.slice(2)}`;
  if (d.length <= 10) return `(${d.slice(0, 2)}) ${d.slice(2, 6)}-${d.slice(6)}`;
  return `(${d.slice(0, 2)}) ${d.slice(2, 7)}-${d.slice(7)}`;
}

/**
 * Validação completa de CPF (algoritmo oficial com dígito verificador).
 * Rejeita todos iguais (ex.: 111.111.111-11) e verifica os dois DVs.
 * @param {string} raw — CPF com ou sem máscara.
 * @returns {boolean}
 */
export function isValidCPF(raw) {
  const cpf = onlyDigits(raw);
  if (cpf.length !== 11) return false;
  if (/^(\d)\1{10}$/.test(cpf)) return false;

  const calcDv = (slice, factorStart) => {
    let sum = 0;
    for (let i = 0; i < slice.length; i++) {
      sum += parseInt(slice[i], 10) * (factorStart - i);
    }
    const rest = (sum * 10) % 11;
    return rest === 10 ? 0 : rest;
  };

  const dv1 = calcDv(cpf.slice(0, 9), 10);
  const dv2 = calcDv(cpf.slice(0, 10), 11);
  return dv1 === parseInt(cpf[9], 10) && dv2 === parseInt(cpf[10], 10);
}

/** Valida email de forma simples (contém @, tem domínio com ponto). */
export function isValidEmail(raw) {
  const s = String(raw || "").trim();
  // RFC-light: suficiente para o contrato do backend (que apenas checa "@")
  return /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(s);
}

/** Telefone válido: 10 ou 11 dígitos. */
export function isValidTelefone(raw) {
  const d = onlyDigits(raw);
  return d.length === 10 || d.length === 11;
}
